// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__11hak","mainContent":"styles_mainContent__EWIeW"};